module.exports = __webpack_public_path__ + "static/img/male.76540f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/male.png
// module id = 1POQ
// module chunks = 1